import React from "react";
import ReactTable from "react-table";
import { toast, } from 'react-toastify';
import { NavLink } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import Assignment from "@material-ui/icons/Assignment";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import { fetchData } from '../../utils/handleApi'
import { styles } from './styles'
class AttachmentTables extends React.Component {

  state = {
    loading: false,
    arrLinks: [],
    showingAttachments: true,
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { showingAttachments } = this.state;
    this.setState({ loading: true })
    fetchData(`order/${showingAttachments ? "attachments" : "orderUpdates"}`, 'post', {
      'order_id': this.props.match.params.orderId
    })
    .then(data => {
      if(data.err){
        this.setState({ loading: false })
        return toast.error('Some error happened!')
      }
      data.map(linkData => {
        let links;
        if(showingAttachments){
          links = linkData.order_attachments.map((number) => ({ link : number.link }))
          return this.setState({
              arrLinks : links,
          })
        } else {
          links = linkData.order_updates.map((number) => ({ link : number.link }))
          return this.setState({
              arrLinks : links,
          })
        }
         
      })
      this.setState({ loading: false })
    })
  }

  render() {
    const { classes } = this.props;
    const { loading, arrLinks, showingAttachments } = this.state;
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader icon>
              <CardIcon color="success">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{showingAttachments ? "Attachments": "Order Updates"}</h4>
              <NavLink to={`/admin/vendor/${this.props.match.params.vendorId}/lender/orders/${this.props.match.params.lenderId}`}>
                <Button 
                  variant="contained"
                  color="primary"
                  style={{
                    float: 'right',
                    margin: '5px',
                    backgroundColor: "rgb(4, 171, 35)"
                  }}
                >
                  Back
                </Button>
              </NavLink>
              <Button 
                variant="contained"
                color="primary"
                style={{
                  float: 'right',
                  margin: '5px',
                  backgroundColor: "rgb(4, 171, 35)"
                }}
                onClick={() => {
                  this.setState({ showingAttachments: !showingAttachments },
                      () => this.fetchData()
                  )}
                }
              >
                 {showingAttachments ? "Show Order Updates": "Show Attachments"}
              </Button>
              
            </CardHeader>
            <CardBody>
              <ReactTable
                loading={loading}
                NoDataComponent={() => !loading && <p style={{textAlign: "center"}}>No {showingAttachments ? "Attachments" : "Order Updates"} available</p>}
                data={arrLinks}
                filterable  
                columns={[
                  {
                    Header: "Links",
                    accessor: "link",
                    Cell: e =><a style={{color: "green"}} href={e.value} target = "_blank" 
                    rel = "noopener noreferrer"> {e.value} </a>,
                    headerStyle: { textAlign: 'left' },
                  }
              ]}
                defaultPageSize={10}
                minRows={0}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight"
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(styles)(AttachmentTables);
